<template>
  <custom-dialog
    class="project-item-dialog"
    :title="model.title"
    width="600px"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col>
            <el-form-item :label="$t('asm_offlineService_modemSn_dialog.tong_xun_banSN')" prop="modemSn">
              <el-input
                v-model="form.modemSn"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('asm_offlineService_modemSn_dialog.shen_qing_yuan_yin')" prop="applyDesc">
              <el-input
                type="textarea"
                :rows="5"
                v-model="form.applyDesc"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ i18n.com_cancel }}
      </el-button>
      <el-button type="primary" @click="onConfirm">
        {{ $t('asm_offlineService_modemSn_dialog.bao_cun_cao_gao') }}
      </el-button>
      <el-button type="primary" @click="onConfirmApply">
        {{ $t('asm_offlineService_modemSn_dialog.ti_jiao_shen_pi') }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';

export default {
  mixins: [dialogMixins, languageInjectMixins],

  data() {
    return {
      inputVisible: false,
      inputValue: '',
      form: {
        // EC032052410001
        applyDesc: '',
        isStartApprove: 0,
        serviceModemId: '',
        modemSn: ''
      },

    };
  },

  computed: {
    rules() {
      return {
        modemSn: [
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
          {
            required: true,
            message: this.$t('Common.com_required')
          }
        ],
        applyDesc: [
          {
            max: 200,
            message: this.$t('Common.com_rules_length_max', [200]),
          },
          {
            required: true,
            message: this.$t('Common.com_required')
          }
        ],
      };
    },
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    // 提交
    onConfirm() {
      if (this.model.type === 'add') {
        this.add();
      } else {
        this.edit();
      }
    },
    // 提交并审批
    onConfirmApply() {
      this.form.isStartApprove = 1;
      this.onConfirm();
    },
    edit() {
      this.$refs.form.validate((val) => {

        if (val) {
          this.$postJSON(apis.serviceModemSaveOrUpdate, this.form, true).then(() => {
            this.$emit('success');
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.i18n.com_edit_success
            });

          });
        }
      });
    },
    add() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.serviceModemSaveOrUpdate, this.form, true).then(() => {
            this.$emit('success');
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.i18n.com_add_success
            });

          });
        }
      });
    },

    // 获取变更详情
    getDetail: function () {
      this.$getJSON(`${apis.serviceModemInfo}/${this.model.serviceModemId}`).then((res) => {
        const detail = res.data || {};
        this.$setFormatData(this.form, detail);
      });
    },
    initForm() {
      if (this.model.type === 'add') {
        return;
      }
      // console.log(this.model.data);
      this.getDetail();
    }
  },
  mounted() {
    this.initForm();
  }
};
</script>

<style lang="scss">
.project-item-dialog {
  .el-tag--small {
    height: 32px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .el-tag + .button-new-tag {
    margin-left: 10px;
  }
  .el-tag + .input-new-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
  }
  .detail-address {
    margin-top: 10px;
  }
}
</style>
